import { t } from 'i18next';
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { baseStyles, buttonStyles } from '@/styles';

@customElement('fg-step-upload-success')
export class FgStepUploadSuccess extends LitElement {
  @property({ type: String })
  fileName = '';

  private resetUpload() {
    this.dispatchEvent(new CustomEvent('reset-upload'));
  }

  render() {
    return html`
      <div class="upload-success">
        <strong>${this.fileName}</strong>
        <button class="button-link" @click=${this.resetUpload}>
          ${t('actions.uploadOtherFile')}
        </button>
      </div>
    `;
  }

  static styles = [
    baseStyles,
    buttonStyles,
    css`
      .upload-success {
        background-color: var(
          --fg-success-background,
          var(--fg-fallback-success-background)
        );
        height: 180px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 5px;
      }
      strong {
        font-size: 1rem;
        line-height: 1.125rem;
      }
    `,
  ];
}
